<label class="mat-body-strong">{{ label }}</label>
<mat-form-field class="am-form-field am-static-suffix" appearance="outline">
  <div>
    <input matInput [value]="displayedPlaceholder$ | async" />
    <input
      class="file-input"
      type="file"
      accept="{{ acceptFileType?.join(', ') }}"
      [formControl]="fileCtrl"
      (change)="handleFileInputChange($event)"
      name="fileInput"
    />
  </div>
</mat-form-field>
